// extracted by mini-css-extract-plugin
export var animationContainer = "_do-0";
export var asteriskIcon = "_do-8";
export var conversationLeftSection = "_do-4";
export var conversationListItem = "_do-3";
export var conversationMiddleSection = "_do-5";
export var conversationRightSection = "_do-6";
export var detailsContent = "_do-1";
export var listContainer = "_do-7";
export var modalContent = "_do-2";